export default __webpack_public_path__ + "static/media/triangles-no-7.685dae77.ogg";